import { encodePaginatableQuery, PaginatableQuery, Query } from '@/services/api';
import * as q from '@/services/api/request/query';

export interface ListChecklistTemplateQuery extends PaginatableQuery {
  checklist?: Array<number>;
}

export const encodeListChecklistTemplateQuery = (query: ListChecklistTemplateQuery): Query => ({
  ...encodePaginatableQuery(query),
  checklist: q.numbers(query.checklist ?? []),
});
